(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["index-collection"] && !Shopify.designMode) return;
  try {
    
$(function() {
  $('.figcaption').matchHeight();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-team"] && !Shopify.designMode) return;
  try {
    
$(function() {
  $('.team__card__text').matchHeight();
});

  } catch(e) { console.error(e); }
})();
})();
